export const SET_SURVEY_CODE = '@@selection/SET_SURVEY_CODE';
export const SET_GEO_FIPS = '@@selection/SET_GEO_FIPS';
export const SET_TABLES = '@@selection/SET_TABLES';
export const SET_DATASETS = '@@selection/SET_DATASETS';
export const SET_REPORT_ID = '@@selection/SET_REPORT_ID';
export const SET_NEW_REPORT_ID = '@@selection/SET_NEW_REPORT_ID';
export const CLEAR_REPORT_ID = '@@selection/CLEAR_REPORT_ID';
export const RESET_SELECTION = '@@selection/RESET_SELECTION';
